import type { Unit } from './getElapsedTime';

const MILLISECOND = 1;
const SECOND = 1000 * MILLISECOND;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const AVERAGE_MONTH = 30 * DAY; // Approximate month (30 days)
const QUARTER = 3 * AVERAGE_MONTH; // Approximate quarter (3 months)
const YEAR = 365 * DAY; // Approximate year

function unitToMillis(unit: Unit) {
  switch (unit) {
    case 'millisecond':
      return MILLISECOND;
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    case 'week':
      return WEEK;
    case 'month':
      return AVERAGE_MONTH;
    case 'quarter':
      return QUARTER;
    case 'year':
      return YEAR;
    case 'date':
      return Date.now(); // Returns current timestamp
    default:
      throw new Error('Invalid time unit provided.');
  }
}

export default unitToMillis;
